import { render, staticRenderFns } from "./SplitsFilter.vue?vue&type=template&id=5cb11960&scoped=true&"
import script from "./SplitsFilter.vue?vue&type=script&lang=js&"
export * from "./SplitsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb11960",
  null
  
)

export default component.exports